import { render, staticRenderFns } from "./WidgetUpdate.vue?vue&type=template&id=64a54064&scoped=true&"
import script from "./WidgetUpdate.vue?vue&type=script&lang=js&"
export * from "./WidgetUpdate.vue?vue&type=script&lang=js&"
import style0 from "./WidgetUpdate.vue?vue&type=style&index=0&id=64a54064&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a54064",
  null
  
)

export default component.exports